export default __webpack_public_path__ + "static/media/hz-logo (2).955c0ce7.svg";